module.exports = __webpack_public_path__ + "static/media/loader.b71b7d60.gif";